/* eslint-disable react-func/max-lines-per-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import service from '@/service';
import { CheckItemProps } from '@/types';
import { CheckType } from '@/constants';
import { RootState } from '../rootReducer';
import { AppThunk } from '..';

export type TabDomProps = {
  type: CheckType;
  fileType?: string[];
  config: CheckItemProps[];
};

type State = {
  // 静态配置项
  workFlows?: any[];
  fileTypes?: any[];

  // 动态配置rule
  tabsDom: TabDomProps[]; //层级缓存
};

const INIT_VALUE = {
  tabsDom: [],
  workFlows: [],
  fileTypes: [],
};

const initialState: State = INIT_VALUE;
// 缓存-服务端控制的配置页面DOM config
const dynamicCheckItemConfig = createSlice({
  name: 'dynamicCheckItemConfig',
  initialState,
  reducers: {
    setTabsDom(state, { payload }: PayloadAction<TabDomProps[]>) {
      state.tabsDom = payload;
    },
    setWorkFlows(state, { payload }: PayloadAction<any[]>) {
      state.workFlows = payload;
    },
    setFileTypes(state, { payload }: PayloadAction<any[]>) {
      state.fileTypes = payload;
    },
  },
});

export const { setWorkFlows, setFileTypes, setTabsDom } = dynamicCheckItemConfig.actions;

export const selectDynamicCheckItemConfig = (state: RootState) => state.dynamicCheckItemConfig;
export const selectDynamicRuleConfig = (state: RootState, checkItemType: CheckType, fileType: string) => {
  const tabsDom = state.dynamicCheckItemConfig.tabsDom;
  let ruleForm;
  tabsDom.forEach(tab => {
    const isFind = tab.type === checkItemType && tab?.fileType?.[0] === fileType;
    isFind && (ruleForm = tab.config);
  });
  return ruleForm;
};

export const getWorkFlows = (): AppThunk => async (dispatch, getState) => {
  const { projectId } = getState().settings.activeProject || {};
  const workFlows = (await service.dynamicCheckItemSetting.getWorkFlow(projectId!)) || [];
  dispatch(setWorkFlows(workFlows));
};

export const getFileType = (): AppThunk => async (dispatch, getState) => {
  const { projectId } = getState().settings.activeProject || {};
  const fileTypes = (await service.dynamicCheckItemSetting.getFileType(projectId!)) || [];
  dispatch(setFileTypes(fileTypes));
};

export default dynamicCheckItemConfig.reducer;
